import request from '@/utils/request'

//加载教官列表
export function getList(params) {
    return request({
        url: '/api/TeacherInfo/LoadQT',
        method: 'get',
        params
    })
}

//通过字典id查询数据
export function getPmiDic(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}



// 获取教官库首页的教案与博客
export function GetBlogList(params) {
    return request({
        url: '/api/TeacherInfo/GetBlogList',
        method: 'get',
        params
    })
}

// 根据id获取教官信息 
export function GetByUserId(params) {
    return request({
        url: '/api/TeacherInfo/GetByUserId',
        method: 'get',
        params
    })
}


export function getById(params) {
    return request({
        url: '/api/TeacherInfo/Get',
        method: 'get',
        params
    })
}




export function getDetail(params) {
    return request({
        url: '/api/TeacherInfo/GetDetail',
        method: 'get',
        params
    })
}


//获取单个博客数据
export function TeacherBlogsGet(params) {
    return request({
        url: '/api/TeacherBlogs/Get',
        method: 'get',
        params
    })
}

//获取博客数据列表
export function TeacherBlogsLoad(params) {
    return request({
        url: '/api/TeacherBlogs/Load',
        method: 'get',
        params
    })
}

export function TeacherGetBlogCount(params) {
    return request({
        url: '/api/TeacherInfo/GetBlogCount',
        method: 'get',
        params
    })
}

export function TeacherGetBlogReadCount(params) {
    return request({
        url: '/api/TeacherBlogs/ReadCount',
        method: 'get',
        params
    })
}

export function TeacherPxhdLoad(params) {
    return request({
        url: '/api/TeacherPxhd/Load',
        method: 'get',
        params
    })
}



export function TeacherCjgzjlLoad(params) {
    return request({
        url: '/api/TeacherCjgzjl/GetMyCjgzjl',
        method: 'get',
        params
    })
}

export function TeacherCjgzjlGet(params) {
    return request({
        url: '/api/TeacherCjgzjl/Get',
        method: 'get',
        params
    })
}

export function TeacherCjgzjlDelete(data) {
    return request({
        url: '/api/TeacherCjgzjl/Delete',
        method: 'post',
        data
    })
}
export function TeacherInfoGetByIdCard(params) {
    return request({
        url: '/api/TeacherInfo/GetByIdCard',
        method: 'get',
        params
    })
}

//通过身份证查询个数据
export function PmiUserGetByIdCard(params) {
    return request({
        url: '/api/PmiUser/GetByIdCard',
        method: 'get',
        params
    })
}


export function update(data) {
    return request({
        url: '/api/TeacherInfo/Update',
        method: 'post',
        data
    })
}
// 教官从教经历
export function TeacherCjgzjlAdd(data) {
    return request({
        url: '/api/TeacherCjgzjl/Add',
        method: 'post',
        data
    })
}




export function TeacherCjgzjlUpdate(data) {
    return request({
        url: '/api/TeacherCjgzjl/Update',
        method: 'post',
        data
    })
}

// 导出教历
export function TeacherInfoExportCjgzjl(params) {
    return request({
        url: '/api/TeacherInfo/ExportCjgzjl',
        method: 'get',
        params
    })
}


//个人训历
export function TeacherPxhdAdd(data) {
    return request({
        url: '/api/TeacherPxhd/Add',
        method: 'post',
        data
    })
}

// 删除训历 
export function TrainSelfDelete(data) {
    return request({
        url: '/api/TrainSelf/Delete',
        method: 'post',
        data
    })
}

// 查询个人训历详情 
export function TrainSelfGet(params) {
    return request({
        url: '/api/TrainSelf/Get',
        method: 'get',
        params
    })
}

export function TrainSelfUpdate(data) {
    return request({
        url: '/api/TrainSelf/Update',
        method: 'post',
        data
    })
}

export function TrainSelfAdd(data) {
    return request({
        url: '/api/TrainSelf/Add',
        method: 'post',
        data
    })
}

export function TeacherPxhdUpdate(data) {
    return request({
        url: '/api/TeacherPxhd/Update',
        method: 'post',
        data
    })
}
// 导出训历
export function TeacherInfoExportPxhd(params) {
    return request({
        url: '/api/TeacherInfo/ExportPxhd',
        method: 'get',
        params
    })
}

export function TeacherPxhdGet(params) {
    return request({
        url: '/api/TeacherPxhd/Get',
        method: 'get',
        params
    })
}

export function TeacherPxhdDelete(data) {
    return request({
        url: '/api/TeacherPxhd/Delete',
        method: 'post',
        data
    })
}

//教官荣誉
export function TeacherRychAdd(data) {
    return request({
        url: '/api/TeacherRych/Add',
        method: 'post',
        data
    })
}
export function TeacherRychUpdate(data) {
    return request({
        url: '/api/TeacherRych/Update',
        method: 'post',
        data
    })
}
export function TeacherRychLoad(params) {
    return request({
        url: '/api/TeacherRych/Load',
        method: 'get',
        params
    })
}

export function getMyTrainOver(params) {
    return request({
        url: '/api/Center/GetMyTrain',
        method: 'get',
        params
    })
}


export function TeacherRychGet(params) {
    return request({
        url: '/api/TeacherRych/Get',
        method: 'get',
        params
    })
}

export function TeacherRychDelete(data) {
    return request({
        url: '/api/TeacherRych/Delete',
        method: 'post',
        data
    })
}